import styles from "./UploadGridItem.module.css";

const NoImage = (props: any) => (
    <div className={props.selectedStyle}>
        <div>
            <div className={styles.UploadStateText}>
                <b> No Image </b>
            </div>
        </div>
    </div>
);
export default NoImage;
